ready(function(){
	var dropdownToggle = document.getElementsByClassName('dropdown__toggle');
	for (var i = 0 ; i < dropdownToggle.length; i++) {
		dropdownToggle[i].addEventListener('click' , function(e){
			var ariaExpendedVal = this.getAttribute('aria-expanded');
			var ariaExpendedNewVal = (ariaExpendedVal == false || ariaExpendedVal == 'false') ? true : false;
			this.setAttribute('aria-expanded', ariaExpendedNewVal);
			this.nextElementSibling.classList.toggle('hidden');
		}, false);
	}
});